import React, { Component } from 'react';
import DataTable from '../../../components/DataTable/index';
import PropTypes from 'prop-types';
import $ from 'jquery';

class AdvancedSalesListGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: []
        };
    }
    componentWillReceiveProps(props) {
        if (props.dataList && props.dataList !== this.props.dataList) {
            let data = props.dataList.map(item => {
                if (item.isTotal) {
                    Object.keys(item).map(key => {
                        if (key !== 'isTotal' && key !== 'grossAmount') {
                            item[key] = '';
                        }
                        return key;
                    });
                    item.stateCode = 'Total';
                }
                return item;
            });
            this.setState({
                data: props.dataList.length > 1 ? data : []
            });
        }
    }
    render() {
        let { singleSelection } = this.props;
        let { data } = this.state;

        return (
            <DataTable
                id="AdvancedsalesListGrid"
                className="centerTitle"
                columns={[
                    {
                        title: 'State',
                        data: 'stateCode'
                    },
                    {
                        title: 'Transaction<br/>Type',
                        data: 'transactionType'
                    },
                    {
                        title: 'Transaction<br/>Description',
                        data: 'transactionDescription'
                    },
                    {
                        title: 'Account<br/>Type Code',
                        data: 'accountTypeCode'
                    },
                    {
                        title: 'Account<br/>Type Name',
                        data: 'accountTypeName'
                    },
                    {
                        title: 'Redemption<br/>Fee Indicator',
                        data: 'redemptionFeeIndicator'
                    },
                    {
                        title: 'Redemption<br/>Fee Rate',
                        data: 'redemptionFeeRate'
                    },
                    {
                        title: 'Redemption Fee<br/>Eligible Shares',
                        data: 'redemptionFeeEligibleShares'
                    },
                    {
                        title: 'Sales Charge<br/>Amount',
                        data: 'salesChargeAmount'
                    },
                    {
                        title: 'Advance<br/>Commission Amount',
                        data: 'advanceCommissionAmount'
                    },
                    {
                        title: 'Underwriter<br/>Commission Amount',
                        data: 'underwriterCommissionAmount'
                    },
                    {
                        title: 'Initial<br/>Purchase Indicator',
                        data: 'initialPurchaseIndicator'
                    },
                    {
                        title: 'Tax Reporting<br/>Indicator',
                        data: 'taxReportingIndicator'
                    },
                    {
                        title: 'Trust<br/>Name',
                        data: 'trustName'
                    },
                    {
                        title: 'Portfolio<br/>Name',
                        data: 'portfolioName'
                    },
                    {
                        title: 'Class<br/>Name',
                        data: 'className'
                    },
                    {
                        title: 'Fund<br/>Cusip',
                        data: 'fundCusip'
                    },
                    {
                        title: 'Trade<br/>Date',
                        data: 'tradeDate'
                    },
                    {
                        title: 'Price Per<br/>Share',
                        data: 'pricePerShare'
                    },
                    {
                        title: 'Share<br/>Amount',
                        data: 'shareAmount'
                    },
                    {
                        title: 'Gross<br/>Amount',
                        data: 'grossAmount'
                    }
                ]}
                data={data}
                pageable
                singleSelection={singleSelection}
                columnFormat={[
                    {
                        targets: [17],
                        render: function(data, type, full) {
                            if (data) {
                                let date = new Date(data);
                                return date.toLocaleDateString('en-US');
                            }
                            else return '';
                        }
                    },
                    {
                        targets: [1, 3, 5, 6, 7, 8, 9, 10, 11, 12],
                        className: 'text-right'
                    },
                    {
                        targets: [19],
                        className: 'text-right',
                        render: function(data, type, full) {
                            if (data) {
                                return (
                                    data
                                        .toFixed(4)
                                        .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                                );
                            }
                            else return '';
                        }
                    },
                    {
                        targets: [18, 20],
                        className: 'text-right',
                        render: function(data, type, full) {
                            if (data) {
                                return (
                                    '$' +
                                    data
                                        .toFixed(2)
                                        .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                                );
                            }
                            else return '';
                        }
                    }
                ]}
                rowFormat={(row, data, dataIndex) => {
                    if (singleSelection) {
                        $(row).css('cursor', 'pointer');
                    }
                    if (data['isTotal']) {
                        $(row).css({'background-color':'#4f6075', 'color':'#fff'});
                    }
                }}
            />
        );
    }
}

AdvancedSalesListGrid.propTypes = {
    dataList: PropTypes.array.isRequired,
    singleSelection: PropTypes.bool
};

AdvancedSalesListGrid.defaultProps = {
    singleSelection: false
};

export default AdvancedSalesListGrid;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/components/AdvancedSalesListGrid.js